import { RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import { ExpandableFormSection, Note, Summary } from "~/components/form";
type CreateFeedsWithLocalOrSmbPathsFeature = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function CreateFeedsWithLocalOrSmbPathsFeature({ isEnabled, onChange }: CreateFeedsWithLocalOrSmbPathsFeature) {
    const description = "Enable/disable the ability to create feeds with Local or SMB paths.";
    const label = "Allow creation with Local or SMB paths";
    const name = "AllowCreationWithLocalOrSmbPaths";
    return (<ExpandableFormSection key="IsConfigureFeedsWithLocalOrSmbPathsEnabled" errorKey="IsConfigureFeedsWithLocalOrSmbPathsEnabled" title={label} summary={isEnabled ? Summary.summary("Enabled") : Summary.default("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name}/>
                <RadioButtonNew value={false} label="Disabled" name={name} hasDefaultMarker={true}/>
            </RadioGroupNew>

            <Note>
                <p>This feature enables users to create NuGet Feeds with Local or SMB paths.</p>
            </Note>
        </ExpandableFormSection>);
}
